

















































































































































































































































// Vue
import { Vue, Component, Prop } from 'vue-property-decorator'

// models
import { EmployeeFinanceModel } from '@/models/config'

// components
import { Input, Select2, Select } from '@/components/form'

// constants
import {
    optionsTelecredito,
    optionsBanks,
    optionsTipocuenta,
    optionsMoneda,
    optionsPaymentFrequency
} from '@/constants'

@Component({
    name: 'FinancesSectionForm',
    components: {
        Input,
        Select2,
        Select
    }
})
export default class FinancesSectionForm extends Vue {
    @Prop({ type: Object, required: true }) finance!: EmployeeFinanceModel
    @Prop({ type: Object, default: () => ({}) }) validations!: {}
    optionsTelecredito = optionsTelecredito
    optionsTipocuenta = optionsTipocuenta
    optionsMoneda = optionsMoneda
    optionsBanks = optionsBanks
    optionsPaymentFrequency = optionsPaymentFrequency
}
